<ng-template #rt let-r="result" let-t="term">
  <ngb-highlight [result]="r.HSN_CODE + '  ' + r.DDC_CODE + ' - ' + r.TRADE_NAME" [term]="t"></ngb-highlight>
</ng-template>

<app-page-header [heading]="'Sale Return'" [icon]="'fa-undo'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="row">
    <div class="form-group col-lg-3">
      <label for="Date">Invoice Number</label><span class="text-danger">&nbsp;*</span>
      <ngx-select-dropdown (change)="getInvoice();" [(ngModel)]="invoice_data"
                           [config]="utils.dropConfig({displayKey: 'INVOICE_NUMBER',placeholder: 'Select  Invoice number',searchOnKey: 'INVOICE_NUMBER'})"
                           [multiple]="false"
                           [options]="invoice_options" class="form-control  select-dropdown"
                           name="sel_tpa_receiver"></ngx-select-dropdown>
    </div>
    <div class="form-group col-lg-3">
      <label>Customer Name</label>
      <input [(ngModel)]="customer" [readOnly]="true" class="form-control " name="name" tabindex="-1"
             type="text">
    </div>
    <div class="form-group col-lg-3">
      <label for="Date">Invoice Date</label>
      <input [max]="getToday()" [ngModel]="sale_return.invoice_date" [readOnly]="true"
             class="form-control "
             id="date" name="date" tabindex="-1" type="text">
    </div>
    <div class="form-group col-lg-3">
      <label for="text">Customer State</label>
      <input [(ngModel)]="sale_return.state" [readOnly]="true" class="form-control " name="State"
             type="text">
    </div>
    <div class="form-group col-lg-3">
      <label for="text">Reference Number</label><span class="text-danger">&nbsp;*</span>
      <input [(ngModel)]="sale_return.reference_no" class="form-control " name="invoice" type="text">
    </div>
    <div class="form-group col-lg-3">
      <label for="Date">Return Date</label><span class="text-danger">&nbsp;*</span>
      <input (ngModelChange)="sale_return.return_date = $event" [max]="getToday()"
             [ngModel]="sale_return.return_date | date:'yyyy-MM-dd'"
             class="form-control " id="date" min="{{date | date:'yyyy-MM-dd'}}" name="date"
             type="date">
    </div>

  </div>
  <hr>
  <h5 class="list-header">Return Particular</h5>
  <div class="clearfix"></div>
  <div class=" form-group">
    <table class="tbl table tbl-sm  table-bordered">
      <thead>
      <tr class="text-center">
        <th></th>
        <th width="1%">#Sl</th>
        <th>Item<span class="text-danger">&nbsp;*</span></th>
        <th width="6%">UOM</th>
        <th width="6%">Qty</th>
        <th width="6%">Rate</th>
        <th width="10%">Price</th>
        <th width="10%"> Total</th>
        <th width="6%">Return Quantity<span class="text-danger">&nbsp;*</span></th>
        <th width="6%">Return Price<span class="text-danger">&nbsp;*</span></th>
        <th width="20%">Return Reason<span class="text-danger">&nbsp;*</span></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let i of utils.buildArray(sale_details.length)">
        <td class="text-center"><input (click)="changeCheckbox(i)" *ngIf="sale_return.quantity_arr[i] > 0 "
                                       [checked]="sale_return.check[i] == true" type="checkbox"></td>
        <td class="text-center">{{ 1 + i }}</td>
        <td>
          <input (selectItem)="set_item_medicine($event,i)" [(ngModel)]="sale_return.medicine_data[i]"
                 [class.is-invalid]="searchFailed" [inputFormatter]="formatter"
                 [ngModelOptions]="{standalone: true}" [ngbTypeahead]="medicine_search" [readOnly]="true"
                 [resultTemplate]="rt"
                 class="form-control" id="typeahead-http{{i}}"
                 placeholder="Search Particular Name...." style="height: 29px;"
                 type="text"/>
        </td>
        <td>
          <input [(ngModel)]="sale_return.uom_arr_name[i]" [readOnly]="true" class="form-control  "
                 name="uom_arr_name{{i}}" tabindex="-1" type="text">
        </td>

        <td>
          <input [(ngModel)]="sale_return.quantity_arr[i]" [readOnly]="true"
                 class="form-control text-center "
                 name="quantity_arr{{i}}" tabindex="-1" type="text">
        </td>
        <td>
          <input [(ngModel)]="sale_return.unitprice_arr[i]" [readOnly]="true"
                 class="form-control text-right "
                 name="unitprice_arr{{i}}" tabindex="-1" type="text">
        </td>
        <td>
          <input [(ngModel)]="sale_return.price_arr[i]" [readOnly]="true"
                 class="form-control text-right "
                 name="price_arr{{i}}" tabindex="-1" type="text">
        </td>
        <td>
          <input [(ngModel)]="sale_return.total_arr[i]" [readOnly]="true"
                 class="form-control text-right  "
                 name="total_arr{{i}}" tabindex="-1" type="text">
        </td>
        <td>
          <input (focusout)="totalAmount();" [(ngModel)]="sale_return.return_qty[i]"
                 [disabled]="sale_return.check[i] == false"
                 class="form-control  " maxlength="7" name="return_qty{{i}}"
                 type="text">
        </td>
        <td>
          <input (focusout)="total()" [(ngModel)]="sale_return.return_amt[i]"
                 [disabled]="sale_return.check[i] == false"
                 class="form-control  " maxlength="7" name="return_amt{{i}}" type="text">
        </td>
        <td>
          <textarea [(ngModel)]="sale_return.return_reason[i]" [disabled]="sale_return.check[i] == false"
                    class="form-control "
                    name="return_reson" style="height: 35px;"
                    type="text"></textarea>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <th class="text-right" colspan="9">Total</th>
        <th class="text-right">{{ total_amount | number : '1.2-2' }}</th>
      </tr>
      </tfoot>
    </table>
  </div>

  <div class="row container">
    <div class="col-lg-7 pull-right">
      <button (click)="saveReturnSale()" *ngIf="user_rights.ADD == '1'" class="btn btn-info btn-sm ng-star-inserted"
              type="button">&nbsp;Save&nbsp;
      </button>
    </div>
  </div>
</div>
